import React from 'react';
import { sendAnalytics } from '../../analytics';
import Dialog from '../../base/ui/components/web/Dialog';
import { Translate } from '../../webjam/language';
import { setConfirmationModalProps } from '../redux/tool-webjam-v3/actions';
import { dispatch } from '../Utils';
import { ct } from '../constant-Utils';

const Embbeded = ({ closeDialog }) => {

	const embbededCode = `<div style='height:720px;width:1280px'><iframe allow='geolocation; microphone; camera' src='${window.location}'  style='width:100%;height:100%'></iframe> </div>`;

	const copyTheCode = () => {
		var copyText = document.getElementById("Embbeded-code");
		copyText.select();
		copyText.setSelectionRange(0, 99999)
		document.execCommand("copy");
		// alert("Copied");
		dispatch(setConfirmationModalProps({
			isShow: true,
			title: ct("Translate.typography.alert"),
			content: "Copied",
			showCancelButton: false,
			successBtnName: ct("Translate.buttonTitle.okSmall"),
			onSuccess: () => {
				dispatch(setConfirmationModalProps({isShow: false}))
			}
		}));
		sendAnalytics({
			action: "toolbar-clicked",
			category: "toolbar",
			source: "Embed on my site Copy code"
		});
	}

	return <Dialog
		disableAutoHideOnSubmit={true}
		disableBackdropClose={true}
		hideCloseButton={true}
		onCancel={() => closeDialog('')}
		onSubmit={() => copyTheCode()}
		cancel={{ translationKey: ct("Translate.buttonTitle.cancelSmall") }}
		ok={{ translationKey: ct("Translate.buttonTitle.copyCode") }}
		titleKey={ct("Translate.messages.copyCodeTitle")}
		testId="embbed-site-link"
		rtaClassName="embbeded-code-modal"
	>
		<textarea
			className="form-control"
			id="Embbeded-code"
			value={embbededCode}
			readOnly
		/>
	</Dialog>
}

export default Embbeded;
